// extracted by mini-css-extract-plugin
export var hideOnDesktop = "Video-module--hideOnDesktop--IFkC0";
export var icon = "Video-module--icon--tiNme";
export var iconHide = "Video-module--icon-hide--IYDup";
export var videoInner = "Video-module--video-inner--pjq9x";
export var videoInnerGray = "Video-module--video-inner-gray--WmAW+";
export var videoInnerRatio__16x9 = "Video-module--video-inner-ratio__16x9--aAPiT";
export var videoInnerRatio__1x1 = "Video-module--video-inner-ratio__1x1--Kg7Rk";
export var videoInnerRatio__3x4 = "Video-module--video-inner-ratio__3x4--2RFQs";
export var videoInnerWhite = "Video-module--video-inner-white--MnZ5N";
export var videoPause = "Video-module--video-pause--kZMIR";
export var videoPoster = "Video-module--video-poster--gACtl";
export var videoPosterHide = "Video-module--video-poster-hide--RCcrS";
export var videoWrapper = "Video-module--video-wrapper--WzJ2x";